import { Button } from '@grupoboticario/flora-react';
import styled from 'styled-components';

export const ActionIcons = styled.div`
  display: flex;
  gap: 20px;
`;

export const ActionContainer = styled(Button).attrs({
  hierarchy: 'tertiary',
})<{ color: string }>`
  display: flex;
  flex-direction: column;
  height: 40px;
  font-size: 10px;
  line-height: initial;
  justify-content: space-between;

  padding: 2px;
  color: ${({ color }) => color};

  span {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  :hover {
    background-color: transparent;
  }
`;

export const FiltersContainer = styled.div`
  display: grid;
  grid-template: repeat(2, 1fr) / repeat(4, 1fr);
  gap: 12px 20px;

  max-width: 728px;
  margin: 20px auto;

  [class*='-indicatorSeparator'] {
    display: none;
  }
  [class*='-indicatorContainer'] {
    svg {
      fill: ${({ theme }) => theme.colors.main};
    }
  }
  [data-flora='select'] {
    height: 64px;
  }

  [data-flora='select'] + label {
    font-size: 1rem;
    font-weight: 500;
    padding-top: 8px;
  }

  div[data-flora-icon='right'] {
    padding-top: 16px;
  }
`;

export const CleanFiltersButton = styled(Button)`
  display: block;
  width: 100%;
  height: 64px;
  // margin: 0 auto 20px;
`;

export const CalendarRef = styled.div`
  position: relative;
  vertical-align: top;
  display: inline-block;
`;

export const CalendarInput = styled.div`
  height: 64px;
  cursor: pointer;
  border: 1px solid ${({ theme }) => theme.colors.textLight};
  border-radius: 4px;
  padding: 6px 11px;
  & span {
    display: block;
    width: 100%;
    text-align: left;
    font-size: 14px;
    color: var(--flora--colors-nonInteractivePredominant);
    padding-top: 6px;
    font-weight: 500;
  }
  & input {
    width: 100%;
    text-align: left;
    border: 0;
    background-color: #fff;
    cursor: pointer;
    font-size: 11px;
  }
`;

export const CalendarIcon = styled.div`
  position: absolute;
  top: 11px;
  right: 13px;
  width: 15px;
  height: 17px;
  background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 18 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4 9H6V11H4V9ZM18 4V18C18 19.1 17.1 20 16 20H2C0.89 20 0 19.1 0 18L0.00999999 4C0.00999999 2.9 0.89 2 2 2H3V0H5V2H13V0H15V2H16C17.1 2 18 2.9 18 4ZM2 6H16V4H2V6ZM16 18V8H2V18H16ZM12 11H14V9H12V11ZM8 11H10V9H8V11Z' fill='%237871D1'/%3E%3C/svg%3E");
`;
